export const getInitials = (name = '') =>
  name
    .replace(/\s+/, ' ')
    .split(' ')
    .slice(0, 2)
    .map(v => v && v[0].toUpperCase())
    .join('');

export const getFormattedString = (str, length) => {
  const strLength = typeof str === 'string' ? str.length : 0;
  if (str.length > length) {
    return `${str.substr(0, length / 2)}...${str.substr(strLength - length / 2)}`;
  }

  return str;
};

export const getPrettyString = (str, prefix = "generic.label") => {
  if (!str) {
    return null;
  }
  const strings = [];

  let currentStr = str.charAt(0).toUpperCase();
  for (let i = 1; i < str.length; i++) {
    const curChar = str.charAt(i);
    if (curChar.match(/[A-Z]/) || curChar.match(/[0-9]/)) {
      strings.push(currentStr);
      currentStr = curChar;
    } else if (curChar.match(/[a-z]/)) {
      currentStr += curChar;
    }
  }
  strings.push(currentStr);

  return {
    string: strings.join(" "),
    id: `${prefix || "generic.label"}.${strings.join(".").toLowerCase()}`
  };
};

export const getStringValue = value => {
  if (value instanceof Date) {
    return value.toDateString();
  }

  return `${value}`;
};

export const getIntlValueFromString = value => {
  if (typeof value !== "string") {
    return ""
  }
  const strVal = (value + "").toLowerCase().trim();
  return strVal.split(" ").join(".");
};

export const getTranslatedValue = (inputStr, intl) => {
  const value = Array.isArray(inputStr) && inputStr.length > 0 ? inputStr[0] : inputStr
  if (typeof value !== "string") {
    return ""
  }
  if (!intl) {
    return value;
  }
  if (!value) {
    return ""
  }

  const strVal = (value + "").toLowerCase().trim();
  const id =  `generic.label.${strVal.split(" ").join(".")}`;
  return intl.formatMessage({id, defaultMessage: value});
}

export const removeSpacesFromString = (inputStr) => {
  if (typeof inputStr !== "string") {
    return inputStr
  }
  if (!inputStr) {
    return ""
  }
  return inputStr.replace(/\s/g, ''); 
}
